import { ReactNode, SyntheticEvent } from 'react';

import cx from 'classnames';

import { useAppDispatch } from 'storeHooks';

import submitThunk from './submit.thunk';

const Form = ({ children, className }: { children: ReactNode; className?: string }) => {
  const dispatch = useAppDispatch();
  const handleSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
    e?.preventDefault();
    // const qty = e?.target?.['quantity-input']?.value;
    dispatch(submitThunk());
  };
  return (
    (<form
      data-testid="placeorder-form"
      onSubmit={e => handleSubmit(e)}
      className={cx(className)}
      data-palette="Form">
      {children}
    </form>)
  );
};

export default Form;
